import apiUrl from '../../../constants'
import axios from 'axios'
import CryptoJS from 'crypto-js';
import {
  Validator
} from 'vee-validate'
import VueElementLoading from 'vue-element-loading';
import {
  BasicSelect
} from 'vue-search-select'
import Paginate from 'vuejs-paginate'
import moment from 'moment'
export default {
  name: 'change-bag-seal',
  components: {
    BasicSelect,
    VueElementLoading,
    Paginate
  },
  props: [],
  data() {
    return {
      isLoading: false,
      isLoadingSearch: false,
      hubzone: '',
      hubzonelist: [],
      hublist: [],
      rowlist: [],
      hub: '',
      location: '',
      locationcapacity:'',
      row: '',
      hubzoneitem: {
        id: '',
        text: ''
      },
      hubitem: {
        value: '',
        text: ''
      },
      rowitem: {
        value: '',
        text: ''
      },
      hubzoneLoading: '',
      hubLoading: '',
      rowLoading: '',
      flthubzonelist: [],
      flthublist: [],
      flthubzoneitem: {
        id: '',
        text: ''
      },
      flthubitem: {
        value: '',
        text: ''
      },
      flthubzone: '',
      flthub: '',
      flthubLoading: '',
      LocationListData: [],
      pageCount: 0,
      pageNo: 0,
      totalRows: 0,
      limit: 10,
      createdby: '',
      userHubid: '',
      updateModal: false,
      modaldata: '',
      locationNoForUpdate:'',
      locationNoError:false,
      locationNoErrorMsg:'',
      locationCapError:false,
      locationCapacityForUpdate:'',
      locationCapErrorMsg:'',
      locationErrorMsg:'',
      locationError:0,
      regexForLocation:/^[a-zA-Z0-9]{1,30}$/,
      updateLocationError:0,
      regexForLocationCapcity:/^[0-9]{1,30}$/,
      hubzoneForUpdate :'',
      hublistForUpdate :[],
      hubzoneitemForUpdate:{
        value: '',
        text: ''
      },
      hubitemForUpdate :{
        value: '',
        text: ''
      },
      rowlistForUpdate:[],
      rowForUpdate:'',
      rowitemForUpdate: {
        value: '',
        text: ''
      },
      hubForUpdate:'',
      rowError:false,
      rowErrorMsg:'',
      statusmodal:false,
      modalDataForStatus:[]

    }
  },
  computed: {},
  filters: {
    moment: function(date) {
      if (date == null || date == '')
        return '--'
      return moment(date).format('DD-MM-YYYY');
    }
  },
  mounted() {
    var userdetailEncrypt = window.localStorage.getItem('userdetail')
    var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
    var plaintext = bytes.toString(CryptoJS.enc.Utf8);
    var userdetail = JSON.parse(plaintext);
    this.createdby = userdetail[0].email
    this.userHubid = userdetail[0].HubId[0]
    this.getHubZone();
  },
  methods: {
    getHubZone() {
      this.hubzoneLoading = 'Loading Hub Zone...'
      var HubZoneListData = []
      this.input = ({})
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubzone/list',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
            HubZoneListData = result.data.ResponseData;
            for (var i = 0; i < HubZoneListData.length; i++) {
              this.hubzonelist.push({
                id: HubZoneListData[i].hubzoneid,
                text: HubZoneListData[i].hubzonename
              })
              this.flthubzonelist.push({
                id: HubZoneListData[i].hubzoneid,
                text: HubZoneListData[i].hubzonename
              })
            }
          } else {
            HubZoneListData = []
          }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })
    },
    selectHubZone(hubzoneitem) {
      this.hubzoneitem = hubzoneitem
      this.hubzone = this.hubzoneitem.text
      this.hublist = []
      this.hubitem = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.hubLoading = ''
      this.rowlist = []
      this.rowitem = {
        value: '',
        text: ''
      }
      this.row = ''
      this.rowLoading = ''
      this.$validator.reset()
      if (this.hubzone != '') {
        this.getHubList()
      }
    },
    selectHubZoneForUpdate(hubzoneitemForUpdate) {
      this.hubzoneitemForUpdate = hubzoneitemForUpdate
      this.hubzoneForUpdate = hubzoneitemForUpdate.id
      this.hublistForUpdate = []
      this.hubitemForUpdate = {
        value: '',
        text: ''
      }
      this.hub = ''
      this.hubLoading = ''
      this.rowlist = []
      this.rowitem = {
        value: '',
        text: ''
      }
      this.row = ''
      this.rowLoading = ''
      this.$validator.reset()
      if (this.hubzoneForUpdate != '') {
        this.getHubListForUpdate()
      }
    },
    selectedFltHubZone(flthubzoneitem) {
      this.flthubzoneitem = flthubzoneitem
      this.flthubzone = this.flthubzoneitem.text
      this.flthublist = []
      this.flthubitem = {
        value: '',
        text: ''
      }
      this.flthub = ''
      this.$validator.reset()
      if (this.flthubzone != '') {
        this.getHubList('IsSearch')
      }
    },
    getHubList(type) {
      if (type == 'IsSearch') {
        this.flthubLoading = 'Loading Hub...'
        var hubzone = this.flthubzoneitem.id
      } else {
        this.hubLoading = 'Loading Hub...'
        var hubzone = this.hubzoneitem.id
      }
      var hubData = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            hubData = result.data.ResponseData
            for (var i = 0; i < hubData.length; i++) {
              this.hublist.push({
                "value": hubData[i].HubID,
                "text": hubData[i].HubName + '(' + hubData[i].HubID + ')',
              })
              this.flthublist.push({
                "value": hubData[i].HubID,
                "text": hubData[i].HubName + '(' + hubData[i].HubID + ')',
              })
            }
          } else {
            hubData = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })
    },
    getHubListForUpdate(type,check) {
      console.log(check,"check");
      // this.rowForUpdate=''
      // this.rowitemForUpdate={
      //         value:'',
      //         text:''
      //       }
      if (type == 'IsSearch') {
        this.flthubLoading = 'Loading Hub...'
        var hubzone = this.hubzoneForUpdate
      } else {
        this.hubLoading = 'Loading Hub...'
        var hubzone = this.hubzoneForUpdate
      }
      var hubData = []
      this.input = ({
        hubZoneId: hubzone
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'hubservicecenter/hub/list',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubLoading = ''
          this.flthubLoading = ''
          if (result.data.ResultCode == 100) {
            hubData = result.data.ResponseData
            for (var i = 0; i < hubData.length; i++) {
              this.hublistForUpdate.push({
                "value": hubData[i].HubID,
                "text": hubData[i].HubName + '(' + hubData[i].HubID + ')',
              })
            }
          } else {
            hubData = []
          }
        }, error => {
          this.hubLoading = ''
          this.flthubLoading = ''
          console.error(error)
        })

    },
    selectHub(hubitem) {
      this.hubitem = hubitem
      this.hub = hubitem.text
      this.rowlist = []
      this.rowitem = {
        value: '',
        text: ''
      }
      this.row = ''
      if (this.hub != '') {
        this.getRowList()
      }
    },
    selectHubForUpdate(hubitemForUpdate) {
      this.hubitemForUpdate = hubitemForUpdate
      this.hubForUpdate = hubitemForUpdate.value
      this.rowlist = []
      this.rowitem = {
        value: '',
        text: ''
      }
      this.row = ''
      if (this.hubForUpdate != '') {
        this.resetRowListForUpdate()
      }
    },
    selectHubFlt(flthubitem) {
      this.flthubitem = flthubitem
      this.flthub = flthubitem.text
    },
    getRowList() {
      this.rowLoading = 'Loading Row...';
      var RowListData = []
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getRowListByHubId?hubId=' + this.hubitem.value,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.rowLoading = '';
          if (result.data.ResultCode == 100) {
            RowListData = result.data.ResponseData;
            for (var i = 0; i < RowListData.length; i++) {
              this.rowlist.push({
                "value": RowListData[i].locationrowmasterid,
                "text": RowListData[i].rownumber,
              })
            }
          } else {
            RowListData = []
            this.rowlist = []
            this.rowLoading = result.data.ReturnMessage
          }
        }, error => {
          this.rowLoading = '';
          console.error(error)
        })
    },
    getRowListForUpdate() {
      this.rowLoading = 'Loading Row...';
      var RowListData = []
      this.rowlistForUpdate=[]
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'getRowListByHubId?hubId=' + this.hubForUpdate,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.rowLoading = '';
          if (result.data.ResultCode == 100) {
            RowListData = result.data.ResponseData;
            for (var i = 0; i < RowListData.length; i++) {
              this.rowlistForUpdate.push({
                "value": RowListData[i].locationrowmasterid,
                "text": RowListData[i].rownumber,
              })
            }
          } else {
            RowListData = []
            this.rowlist = []
            this.rowLoading = result.data.ReturnMessage
          }
        }, error => {
          this.rowLoading = '';
          console.error(error)
        })
    },
     SelectedRowForUpdate(rowitemForUpdate) {
      this.rowitemForUpdate = rowitemForUpdate
      this.rowForUpdate = rowitemForUpdate.text
    },
    SelectedRow(rowitem) {
      this.rowitem = rowitem
      this.row = rowitem.text
    },
    getLocationList() {
      this.isLoadingSearch = true;
      this.LocationListData = []
      this.input = ({});
      axios({
          method: 'GET',
          'url': apiUrl.api_url_hubops + 'listLocationMaster?hubId=' + this.flthubitem.value + '&offset=' + this.pageNo + '&limit=' + this.limit,
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoadingSearch = false;
          if (result.data.ResultCode == 100) {
            this.LocationListData = result.data.ResponseData;
            this.totalRows = result.data.TotalCount
            if (this.totalRows < 10) {
              this.pageCount = 1
            } else {
              this.pageCount = Math.ceil(this.totalRows / 10);
            }
          } else {
            this.LocationListData = []
            this.totalRows = 0
            this.$alertify.error(result.data.ReturnMessage)
          }
        }, error => {
          this.isLoadingSearch = false;
          console.error(error)
        })
    },
    addLocation() {
      this.locationErrorMsg="";
      this.locationError=0;
      if(this.regexForLocation.test(this.location) == false)
      {
        this.locationError=1;
        this.locationErrorMsg="Location Name Must Be AlphaNumeric";
        return false;
      }
      this.isLoading = true;
      this.input = ({
        "locationRowMasterId": this.rowitem.value,
        "locationNumber": this.location,
        "locationCapacity": this.locationcapacity,
        "createdBy": this.createdby,
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'addLocation',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.isLoading = false;
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.resetForm();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          this.isLoading = false;
          console.error(error)
        })
    },
    updateLocation() {
      this.locationErrorMsg="";
      this.locationError=0;
      this.locationCapError=0
      this.locationCapErrorMsg="";
      this.rowError=false,
      this.rowErrorMsg=""

      this.updateLocationError=0;
      if(this.locationCapacityForUpdate && this.regexForLocationCapcity.test(this.locationCapacityForUpdate) == false)
      {
        this.locationCapError=true;
        this.locationCapErrorMsg="Location Capacity Must Be Numeric";
        this.updateLocationError=1;
      }
      if(this.locationNoForUpdate && this.regexForLocation.test(this.locationNoForUpdate) == false)
      {
        this.locationNoError=true;
        this.locationNoErrorMsg="Location Name Must Be AlphaNumeric";
        this.updateLocationError=1;
      }
      if(!this.locationNoForUpdate)
      {
        this.locationNoError=true,
        this.locationNoErrorMsg="Enter Location"
        this.updateLocationError=1;
      }
      if(!this.locationCapacityForUpdate)
      {
        this.locationCapError=true,
        this.locationCapErrorMsg="Enter Capacity"
        this.updateLocationError=1;
      }
      if(!this.rowForUpdate)
      {
        this.rowError=true,
        this.rowErrorMsg="Select Row"
        this.updateLocationError=1;
      }
      if(this.updateLocationError==1)
      {
        return false;
      }

      this.input = ({
        "locationMasterId": this.modaldata.locationmasterid,
        "locationNumber": this.locationNoForUpdate.trim(),
        "locationRowMasterId": this.rowitemForUpdate.value,
        "locationCapacity": this.locationCapacityForUpdate,
        "isActive": this.modaldata.isactive,
        "LastModifiedBy": this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateLocation',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeUpdateLocationModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })
    },
    openUpdateLocationModal(data) {
      this.locationNoForUpdate=data.locationnumber
      this.locationCapacityForUpdate=data.locationcapacity
      this.hubForUpdate=data.hubid
      this.rowForUpdate=data.locationrowmasterid
      this.rowitemForUpdate={
              value:data.locationrowmasterid,
              text:data.rownumber
            },
      this.hubzoneLoading = 'Loading Hub Zone...'
      if(data.hubid)
      {
        this.input = ({
          id: data.hubid
        })
      }
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'expose/hubservicecenter/hub/get',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          this.hubzoneLoading = ''
          if (result.data.ResultCode == 100) {
          this.HubZoneListDataForUpdate = result.data.ResponseData[0];
          this.hubitemForUpdate={
            value: this.HubZoneListDataForUpdate.HubID,
            text: this.HubZoneListDataForUpdate.HubName
          };
          this.hubzoneForUpdate=this.HubZoneListDataForUpdate.HubZoneId
          if (this.hubzoneForUpdate != '') {
            var check=1;
            this.getHubListForUpdate(check)
          }
          this.hubzoneitemForUpdate={
            value: this.HubZoneListDataForUpdate.HubZoneId,
            text: this.HubZoneListDataForUpdate.hubzonename
          };
        }
        else{
          this.HubZoneListDataForUpdate = []
        }
        }, error => {
          this.hubzoneLoading = ''
          console.error(error)
        })

      this.updateModal = true
      this.modaldata = data
      this.hubzoneForUpdate=this.hubzoneitemForUpdate.value

      if(this.hubForUpdate){
        this.getRowListForUpdate()
      }
    },
    resetRowListForUpdate(){
      this.rowForUpdate=''
      this.rowitemForUpdate={
              value:'',
              text:''
            }
    this.getRowListForUpdate()
    },
    closeUpdateLocationModal() {
      this.updateModal = false,
      this.locationNoForUpdate='',
      this.locationNoError=false,
      this.locationNoErrorMsg='',
      this.locationCapError=false,
      this.locationCapacityForUpdate='',
      this.locationCapErrorMsg=''
      this.rowError=false,
      this.rowErrorMsg=''
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getLocationList()
    },
    getPaginationData(pageNum) {
      this.pageNo = (pageNum - 1)
      this.getLocationList()
    },
    resetFlt() {
      this.totalRows=0
      this.flthubzone = ''
      this.flthub = '',
        this.flthubzoneitem = {
          id: '',
          text: ''
        }
      this.flthubitem = {
          value: '',
          text: ''
        },
        this.LocationListData = []
      this.hubzoneLoading = ''
      this.flthubLoading = ''
      this.$validator.reset();
    },
    resetForm() {
      this.totalRows = 0;
      this.pageCount = 0;
      this.hubzone = ''
      this.hub = ''
      this.row = ''
      this.location = ''
      this.locationcapacity = ''
      this.hubzoneitem = {
          id: '',
          text: ''
        },
        this.hubitem = {
          value: '',
          text: ''
        },
        this.rowitem = {
          value: '',
          text: ''
        },
        this.hubzoneLoading = ''
      this.hubLoading = ''
      this.rowLoading = ''
      this.$validator.reset();
    },
    onSubmit: function(event) {
      this.$validator.validateAll().then((result) => {
        if (!result) {
          this.rowLoading = ''
          return false;
        } else {
          this.addLocation()
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    onSubmitFlt: function(Flt) {
      this.$validator.validateAll('Flt').then((result) => {
        if (!result) {
          return false;
        } else {
          this.getLocationList();
        }
      }).catch(() => {
        console.log('errors exist', this.errors)
      });
    },
    openStatusModal(data) {
      this.statusmodal = true
      this.modalDataForStatus = data
    },
    closeStatusModal() {
      this.statusmodal = false,
      this.modalDataForStatus=[],
      $(document.body).removeClass("modal-open");
      $(".modal-backdrop").remove();
      this.getRowList();
    },
    UpdateLocationStatus(){
      var newStatus=this.modalDataForStatus.isactive?0:1;
      this.input = ({
        "locationMasterId": this.modalDataForStatus.locationmasterid,
        "isActive": newStatus,
        "LastModifiedBy":this.createdby
      })
      axios({
          method: 'PUT',
          'url': apiUrl.api_url_hubops + 'updateLocation',
          'data': this.input,
          headers: {
            'authorization': 'authkey xB84JJ89Hd25',
          }
        })
        .then(result => {
          if (result.data.ResultCode == 100) {
            this.$alert(result.data.ReturnMessage, "", "success");
            this.closeStatusModal();
          } else {
            this.$alert(result.data.ReturnMessage, "", "error");
          }
        }, error => {
          console.error(error)
        })

    }
  }
}



// WEBPACK FOOTER //
// ./src/views/components/locationMaster/locationMaster.js